import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SidePanel.css';

const tabs = [
  { key: 'manage-slots', label: 'Manage Slots' },
//   { key: 'user-update', label: 'User Update' },
//   { key: 'clinic-settings', label: 'Clinic Settings' },
];

const SidePanel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const currentTab = location.pathname.split('/').pop();

  return (
    <aside className={`side-panel ${isOpen ? 'open' : ''}`}>
      <button className="hamburger-btn" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>
      <nav className="tab-list">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`tab-button ${currentTab === tab.key ? 'active' : ''}`}
            onClick={() => {
              navigate(`/configurations/${tab.key}`);
              setIsOpen(false);
            }}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default SidePanel;
